module.exports = __webpack_public_path__ + "src/img/artist/artist04.jpg?de32538f1e93579f1e866ebbb620e19f";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist04.jpg
// module id = 111
// module chunks = 0